import {UserManagerSettings} from "oidc-client";
import {createUserManager} from "redux-oidc";
import {conf} from "./../constants/config/configVars";

const { protocol, hostname, port } = window.location;
const rootUri = `${protocol}//${hostname}${port ? `:${port}` : ''}`

const userManagerConfig: UserManagerSettings = {
  authority: "https://campaign-identity.com",
  automaticSilentRenew: true,
  client_id: "generator.ui",
  loadUserInfo: true,
  post_logout_redirect_uri: `${rootUri}/index.html?oidc=signed-out`,
  redirect_uri: conf.redirect_uri,
  // redirect_uri: `${window.location.protocol}//${window.location.hostname}:${window.location.port}/index.html?oidc=signed-in`,
  // redirect_uri: `${window.location.protocol}//${window.location.hostname}/generator-ui/index.html?oidc=signed-in`,
  // redirect_uri: `http://localhost:3000/index.html?oidc=signed-in`,
  response_type: "id_token token",
  scope: "openid profile generator.rw cid.reg",
  silent_redirect_uri: `${rootUri}/silent_renew.html`
};

const userManager = createUserManager(userManagerConfig);
export default userManager;



// WEBPACK FOOTER //
// ./src/utils/userManager.ts